import React, { Component } from 'react'
import { Grid, Header, Modal, Search, Segment, Table, Icon, Button, Confirm, Dimmer, Loader } from 'semantic-ui-react';
import { searchServiceSeller, singleBuyerRequestBidsHistory, updateBidSellerAvailability } from 'services/Manager';
import './ServiceRequestBidHistory.less';
import moment from 'moment-timezone';
import { discountedPriceDisplay, priceDisplay } from 'helpers/price';
import DGTextbox from 'components/FormControls/Textbox/DGTextbox';
import DGDateTimePicker from 'components/FormControls/DateTimePicker/DGDateTimePicker';
import Formsy, { addValidationRule } from 'formsy-react';
import { placeBid } from 'services/Manager';
import { GeneralError } from 'components/GeneralError/GeneralError';
import done from '../../assets/images/newui/done.svg'
import bid_icon from '../../assets/images/newui/newrequestpage/bid-icon.svg'


const initialState = {
    bids: [],
    searchSellerPhrase: '',
    sellers: [],
    searchingSellers: false,
    selectedSeller: {},
    bidValue: 0,
    sellerAvailability: null,
    loading: false,
    bidSubmissionMessage: '',
    showBidPlacementConfirmation: false,
    loadingText: '',
    windowWidth: window.innerWidth,
    editBidID: 0,
    newSellerAvailability: null,
    existingSellerAvailability: null,
    showAvailabilityUpdateConfirmation: false
};

addValidationRule('isMoreThanZero', function (values, value, otherField) {
    // The this context points to an object containing the values
    // {childAge: "", parentAge: "5"}
    // otherField argument is from the validations rule ("childAge")
    return Number(value > 0);
});
class ServiceRequestBidHistory extends Component {

    constructor(props) {
        super(props);
        this.state = initialState;
        this.bidPriceTextBoxRef = null;
    }

    async componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth });

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    componentDidMount() {
        this.fetchBidHistory();
    }

    componentDidUpdate(prevProps) {
        if (
            //prevProps.open !== this.props.open && this.props.open === true && 
            prevProps.singleBuyerRequestID != this.props.singleBuyerRequestID) {
            this.fetchBidHistory();
        }
    }

    fetchBidHistory = async () => {
        this.setState({ loadingText: 'Loading', loading: true })
        const bidHistory = await singleBuyerRequestBidsHistory(this.props.singleBuyerRequestID);
        if (bidHistory.resStatus === 200) {
            setTimeout(() => {
                this.setState({ bids: bidHistory.data, loading: false, loadingText: '' });
            }, 500);
        }
    }

    // modalCloseHandler = () => {
    //     if (!this.state.submittingBid) {
    //         this.resetState();
    //         this.props.onClose();
    //     }
    // }

    // onSellerSearchChange = (e, data) => {
    //     this.setState({ searchSellerPhrase: data.value, searchingSellers: true });
    //     if (this.searchSellerTimer)
    //         clearTimeout(this.searchSellerTimer);

    //     this.searchSellerTimer = setTimeout(() => {
    //         if (this.state.searchSellerPhrase.length > 0) {
    //             searchServiceSeller(this.props.serviceid, this.state.searchSellerPhrase).then((response) => {
    //                 if (response.resStatus === 200) {
    //                     let sellers = [];
    //                     response.data.map((seller) => {
    //                         sellers.push({ id: seller.sellerID, title: seller.name });
    //                     })

    //                     this.setState({ sellers: sellers });
    //                 }

    //                 this.setState({ searchingSellers: false });

    //             });
    //         }
    //         else {
    //             this.setState({ sellers: [], selectedSeller: {}, searchingSellers: false });
    //         }

    //     }, 600);

    // }

    // onSellerSelection = (e, data) => {

    //     this.setState({ selectedSeller: data.result, searchSellerPhrase: data.result.title }, () => {
    //         if (this.bidPriceTextBoxRef) {
    //             this.bidPriceTextBoxRef.inputRef.current.focus();
    //         };
    //     });
    // }

    // handleSellerSelectionReset = () => {
    //     this.setState({ searchSellerPhrase: '', selectedSeller: {}, searchingSellers: false });
    // }

    // onBidAmountChange = (e, { value }) => {
    //     this.setState({ bidValue: Number(value) });
    // }

    // onBidAvailabilityChange = (date) => {
    //     this.setState({ sellerAvailability: date });
    // }

    // onValidBidSubmit = async () => {
    //     this.setState({ showBidPlacementConfirmation: true, bidSubmissionMessage: '' });
    // }

    // onBidSubmissionClick = async () => {
    //     this.setState({ loading: true, loadingText: 'Submitting bid', bidSubmissionMessage: '', showBidPlacementConfirmation: false });
    //     const placeBidResponse = await placeBid(this.props.singleBuyerRequestID, { bidPrice: this.state.bidValue, sellerID: this.state.selectedSeller.id, sellerAvailability: this.state.sellerAvailability });
    //     if (placeBidResponse.resStatus === 200) {
    //         this.setState({ selectedSeller: {}, bidValue: 0, submittingBid: false, searchSellerPhrase: '' }, () => {
    //             this.fetchBidHistory();
    //         });
    //     }
    //     else {
    //         this.setState({ bidSubmissionMessage: placeBidResponse.message, submittingBid: false, showBidPlacementConfirmation: false })
    //     }
    // }

    // onBidSubmissionCloseOrCancel = () => {
    //     this.setState({ showBidPlacementConfirmation: false });
    // }

    // resetState = () => {
    //     this.setState({ ...initialState });
    // }

    // getColumnHeaderForSmallerDevices(columnName) {
    //     if (this.state.windowWidth < 768) {
    //         return <div className='table-cell-label'>
    //             {columnName}
    //         </div>
    //     }
    // }

    displayAvailability = (sellerAvailability) => {
        let availabilityList = '';

        if (sellerAvailability && sellerAvailability.length > 0) {
            availabilityList = _.map(sellerAvailability, (availability) => {
                return moment.tz(availability, this.props.timezone).format('DD MMM YYYY hh:mmA')
            }).join(', ')
        }

        return availabilityList.length > 0 ? availabilityList : '';
    }

    editSellerAvailability = (sellerBidHistoryID, sellerAvailability) => {
        this.setState({ editBidID: sellerBidHistoryID });
    }

    onExistingSellerAvailabilityChange = (date) => {
        this.setState({ newSellerAvailability: date });
    }


    saveSellerAvailability = async () => {
        const response = await updateBidSellerAvailability(this.state.editBidID, { sellerAvailability: this.state.newSellerAvailability.format('YYYY-MM-DD HH:mm:ss') });
        if (response.resStatus === 200) {
            this.setState({ editBidID: 0, newSellerAvailability: null, showAvailabilityUpdateConfirmation: false }, () => {
                this.fetchBidHistory();
            });
        }
    }

    confirmSellerAvailabilityEdit = () => {
        this.setState({ showAvailabilityUpdateConfirmation: true });
    }

    cancelEditSellerAvailability = () => {
        this.setState({ editBidID: 0 });
    }

    onChangeAvailabilityConfirmationClose = () => {
        this.setState({ showAvailabilityUpdateConfirmation: false });
    }
    //  [
    //      {"seller":{"sellerID":1,"name":"seller1","rating":5},"bid":{"sellerBidHistoryID":2,"singleBuyerRequestID":1,"price":95,"bidOn":"2021-08-16T17:59:17.323Z","lostAt":null,"sellerAvailability":null,"discountAmount":null,"discountPercent":null,"acceptedOn":"2021-08-16T18:07:57.941Z"}},
    //      {"seller":{"sellerID":1,"name":"seller1","rating":5},"bid":{"sellerBidHistoryID":1,"singleBuyerRequestID":1,"price":100,"bidOn":"2021-08-16T17:58:15.238Z","lostAt":"2021-08-16T17:59:17.000Z","sellerAvailability":null,"discountAmount":null,"discountPercent":null,"acceptedOn":null}}]

    openBidHistoryModal = () => {
        this.props.openModal();
    }
    expandBidHistory = () => {
        this.props.expandComponent();
    }

    render() {
        const { bids } = this.state;
        return (
            <>
                <div className={`service-request-bit-table-container form-container ${this.props.isExpand ? "expand" : ""} ${this.state.loading ? "loading" : ""}`}  >
                    <Confirm className="confirm"
                        size="large"
                        open={this.state.showAvailabilityUpdateConfirmation}
                        closeOnDimmerClick
                        closeOnEscape
                        content="Do you want to change seller availability?"
                        onConfirm={this.saveSellerAvailability}
                        onCancel={this.onChangeAvailabilityConfirmationClose}
                        onClose={this.onChangeAvailabilityConfirmationClose}
                    />
                    {
                        this.state.loading ?
                            <Dimmer active={true}>
                                <Loader active={true} size='massive'  > </Loader>
                            </Dimmer>
                            :
                            <>
                                <div className={"header-container"}>
                                    <div className={"heading"}>
                                        {"Bid History"}
                                    </div>
                                    <div className={"actions-container"}>
                                        {
                                            this.props.bidPlacementSearchEnabled && <button onClick={() => this.openBidHistoryModal()} className={"add-button"}>
                                                <div className={"button-text"}>
                                                    {"Place Bid"}
                                                </div>
                                                <img src={bid_icon}></img>
                                            </button>
                                        }

                                        
                                        {
                                            window.innerWidth > 768 &&
                                            <div onClick={() => this.expandBidHistory()} data-tooltip={`${this.props.isExpand ? 'Compress' : 'Expand'}`} data-position="left center" data-inverted="" className={"expend-icon-container"}>
                                                {
                                                    this.props.isExpand ?
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="19.036" height="18.953" viewBox="0 0 19.036 18.953">
                                                            <g id="Group_15460" data-name="Group 15460" transform="translate(0.527 0.501)">
                                                                <g id="Group_15457" data-name="Group 15457" transform="translate(0 0.001)">
                                                                    <path id="Path_29151" data-name="Path 29151" d="M5.791,5.038c0-.1,0-.151,0-.206q-.01-1.211-.019-2.423c0-.354.14-.483.495-.5.538-.024.64.125.637.622-.008,1.186.007,2.372.012,3.559,0,.155,0,.311,0,.466a.373.373,0,0,1-.384.4q-2.128.005-4.256,0a.419.419,0,0,1-.424-.406c0-.01,0-.02,0-.03-.048-.544.19-.7.658-.692.752.017,1.5,0,2.257,0h.209c-.08-.082-.132-.138-.187-.191Q2.509,3.371.225,1.1A.584.584,0,0,1,.037.45a.556.556,0,0,1,.917-.2L4.739,4l.914.907c.035.035.072.068.138.13" transform="translate(0 -0.081)" fill="#bcb0a2" stroke="#bcb0a2" stroke-width="1" />
                                                                    <path id="Path_29152" data-name="Path 29152" d="M5.744,366.824a1.611,1.611,0,0,1-.138.18q-2.295,2.279-4.592,4.555a.558.558,0,0,1-.9-.026.554.554,0,0,1,.1-.751q1.234-1.23,2.469-2.458,1.085-1.078,2.172-2.155c.035-.035.069-.072.135-.143H4.8l-2.409,0a.466.466,0,0,1-.528-.53c0-.02,0-.04,0-.061,0-.382.151-.534.529-.534l2.166,0H6.5a.393.393,0,0,1,.429.474c-.01.1,0,.21,0,.315q-.009,1.893-.018,3.787c0,.337-.129.464-.467.467h-.2a.41.41,0,0,1-.463-.468c0-.818.013-1.636.019-2.454,0-.054,0-.108,0-.162l-.057-.038" transform="translate(-0.009 -353.826)" fill="#bcb0a2" stroke="#bcb0a2" stroke-width="1" />
                                                                    <path id="Path_29153" data-name="Path 29153" d="M366.754,4.946c.052-.06.1-.124.155-.18l4.554-4.53a.618.618,0,0,1,.547-.23.539.539,0,0,1,.453.354.519.519,0,0,1-.119.574c-.252.262-.513.515-.771.772L367.64,5.616c-.031.031-.059.065-.111.123h.189c.8,0,1.6,0,2.394,0A.457.457,0,0,1,370.6,6a.712.712,0,0,1-.051.707.438.438,0,0,1-.39.157q-1.848-.008-3.7-.009c-.162,0-.323.006-.485,0a.367.367,0,0,1-.379-.385q.01-2.111.02-4.223a.365.365,0,0,1,.194-.38.921.921,0,0,1,.706,0,.374.374,0,0,1,.206.39c-.006.828-.007,1.656-.009,2.484,0,.055,0,.11,0,.166l.042.032" transform="translate(-354.5 0)" fill="#bcb0a2" stroke="#bcb0a2" stroke-width="1" />
                                                                    <path id="Path_29154" data-name="Path 29154" d="M367.077,367.051c0,.085,0,.134,0,.183q0,1.235.007,2.469c0,.344-.132.473-.472.484-.464.016-.641-.049-.637-.624.01-1.207-.006-2.414-.012-3.62,0-.115.005-.231,0-.345a.385.385,0,0,1,.416-.455H369.1c.48,0,.96,0,1.439,0a.427.427,0,0,1,.471.453c0,.06,0,.121,0,.182a.46.46,0,0,1-.5.489q-1.212,0-2.424,0h-.2c.059.062.094.1.131.138q2.309,2.3,4.62,4.592a.575.575,0,0,1,.179.642.545.545,0,0,1-.869.235c-.189-.158-.359-.34-.534-.515l-4.211-4.188c-.032-.032-.066-.062-.128-.121" transform="translate(-354.853 -354.06)" fill="#bcb0a2" stroke="#bcb0a2" stroke-width="1" />
                                                                </g>
                                                            </g>
                                                        </svg>

                                                        :
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="19.002" height="18.946" viewBox="0 0 19.002 18.946">
                                                            <g id="Group_15457" data-name="Group 15457" transform="translate(0.5 0.5)">
                                                                <path id="Path_29152" data-name="Path 29152" d="M5.744,366.824a1.611,1.611,0,0,1-.138.18q-2.295,2.279-4.592,4.555a.558.558,0,0,1-.9-.026.554.554,0,0,1,.1-.751q1.234-1.23,2.469-2.458,1.085-1.078,2.172-2.155c.035-.035.069-.072.135-.143H4.8l-2.409,0a.466.466,0,0,1-.528-.53c0-.02,0-.04,0-.061,0-.382.151-.534.529-.534l2.166,0H6.5a.393.393,0,0,1,.429.473c-.01.1,0,.21,0,.315q-.009,1.893-.018,3.786c0,.337-.129.464-.467.467h-.2a.41.41,0,0,1-.463-.468c0-.818.013-1.636.019-2.453,0-.054,0-.108,0-.162l-.057-.038" transform="translate(11.071 -364.898)" fill="#bcb0a2" stroke="#bcb0a2" stroke-width="1" />
                                                                <path id="Path_29153" data-name="Path 29153" d="M366.754,4.945c.052-.06.1-.124.155-.18L371.462.236a.618.618,0,0,1,.547-.23.539.539,0,0,1,.453.354.519.519,0,0,1-.119.574c-.252.262-.513.515-.771.772L367.64,5.615c-.031.031-.059.065-.111.123h.189c.8,0,1.6,0,2.394,0a.457.457,0,0,1,.484.264.712.712,0,0,1-.051.707.438.438,0,0,1-.39.157q-1.848-.008-3.7-.009c-.162,0-.323.006-.485,0a.367.367,0,0,1-.379-.385q.01-2.111.02-4.222a.365.365,0,0,1,.194-.38.921.921,0,0,1,.706,0,.374.374,0,0,1,.206.39c-.006.828-.007,1.656-.009,2.484,0,.055,0,.11,0,.166l.042.032" transform="translate(-365.594 11.078)" fill="#bcb0a2" stroke="#bcb0a2" stroke-width="1" />
                                                            </g>
                                                        </svg>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className={"bids-container"}>
                                    <div className={"bids-list"}>

                                        {
                                            !_.isEmpty(bids) && bids.map((bid, bidIndex) => {
                                                return (

                                                    <>
                                                        <div className={"bids-list-item"}>
                                                            <div className={"price-availability-container"}>
                                                                <div className={"price-container"}>
                                                                    <div className={"cell-heading"}>
                                                                        {"Price"}
                                                                    </div>
                                                                    <div className={"price"}>
                                                                        {(bid.bid.discountAmount > 0 || bid.bid.discountPercent > 0) &&
                                                                            <div>
                                                                                <span className={"discount-container"}>
                                                                                    {priceDisplay(bid.bid.price)}
                                                                                </span>
                                                                                <span>
                                                                                    {discountedPriceDisplay(bid.bid.price, bid.bid.discountPercent, bid.bid.discountAmount)}
                                                                                </span>
                                                                            </div>
                                                                        }

                                                                        {(!bid.bid.discountAmount && !bid.bid.discountPercent) && <div>
                                                                            <span>{priceDisplay(bid.bid.price)}</span>
                                                                        </div>
                                                                        }

                                                                    </div>
                                                                </div>
                                                                <div className={"availability-container"}>
                                                                    <div className={"cell-heading"}>
                                                                        <div style={{ display: "inline-block" }}>
                                                                            {"Availability "}
                                                                        </div>
                                                                        {
                                                                            (bid.bid.sellerBidHistoryID == this.state.editBidID) && this.props.isRequestAccepted == false &&
                                                                            <div className={"button-container"} >
                                                                                <div onClick={this.confirmSellerAvailabilityEdit} className="save" >
                                                                                    {/* <Icon name="check circle outline" onClick={this.confirmSellerAvailabilityEdit} /> &nbsp; */}
                                                                                    <svg id="Group_15488" data-name="Group 15488" xmlns="http://www.w3.org/2000/svg" width="25.175" height="25.175" viewBox="0 0 25.175 25.175">
                                                                                        <path id="Path_29156" data-name="Path 29156" d="M733.938,186.933c.941-.745,1.853-1.471,2.77-2.192q2.734-2.15,5.473-4.294c.413-.324.821-.655,1.24-.972a1.193,1.193,0,0,1,1.01-.282.827.827,0,0,1,.593,1.2,2.016,2.016,0,0,1-.392.542q-4.74,4.742-9.49,9.474a1.638,1.638,0,0,1-2.38.008q-2.095-2.074-4.173-4.166a1.643,1.643,0,0,1-.037-2.275,1.625,1.625,0,0,1,2.284-.121c.678.623,1.315,1.29,1.968,1.94C733.181,186.17,733.555,186.548,733.938,186.933Z" transform="translate(-724.027 -172.46)" fill="#7ac943" />
                                                                                        <circle id="Ellipse_482" data-name="Ellipse 482" cx="12.587" cy="12.587" r="12.587" transform="translate(0 0)" fill="#82c43c" opacity="0.1" />
                                                                                    </svg>
                                                                                </div>
                                                                                <div onClick={this.cancelEditSellerAvailability} className="cancel">
                                                                                    {/* <Icon name="delete " onClick={this.cancelEditSellerAvailability} /> &nbsp; */}
                                                                                    <svg id="Group_15487" data-name="Group 15487" xmlns="http://www.w3.org/2000/svg" width="25.175" height="25.175" viewBox="0 0 25.175 25.175">
                                                                                        <defs>
                                                                                            <clipPath id="clip-path">
                                                                                                <path id="Close" d="M.225,10.9a.769.769,0,0,0,1.086,0L5.562,6.648,9.814,10.9A.768.768,0,0,0,10.9,9.814L6.648,5.562,10.9,1.311A.768.768,0,1,0,9.814.225L5.562,4.476,1.311.225A.768.768,0,0,0,.225,1.311L4.476,5.562.225,9.814A.769.769,0,0,0,.225,10.9Z" fill="#ff5457" stroke="#ff5457" stroke-width="1" />
                                                                                            </clipPath>
                                                                                        </defs>
                                                                                        <g id="Group_15485" data-name="Group 15485" transform="translate(0 0)">
                                                                                            <g id="Group_13547" data-name="Group 13547">
                                                                                                <circle id="Ellipse_481" data-name="Ellipse 481" cx="12.587" cy="12.587" r="12.587" transform="translate(0 0)" fill="#ffebf6" />
                                                                                            </g>
                                                                                        </g>
                                                                                        <g id="Group_15486" data-name="Group 15486" transform="translate(7.662 7.32)">
                                                                                            <path id="Close-2" data-name="Close" d="M.225,10.9a.769.769,0,0,0,1.086,0L5.562,6.648,9.814,10.9A.768.768,0,0,0,10.9,9.814L6.648,5.562,10.9,1.311A.768.768,0,1,0,9.814.225L5.562,4.476,1.311.225A.768.768,0,0,0,.225,1.311L4.476,5.562.225,9.814A.769.769,0,0,0,.225,10.9Z" transform="translate(0 0)" fill="#ff5457" stroke="#ff5457" stroke-width="1" />
                                                                                        </g>
                                                                                    </svg>
                                                                                </div>
                                                                            </div>
                                                                        }

                                                                    </div>
                                                                    {(bid.bid.sellerBidHistoryID != this.state.editBidID) && bid.bid.sellerAvailability && bid.bid.sellerAvailability.length > 0 &&
                                                                        <>
                                                                            <div className={`edit-availability available-date ${this.props.isRequestAccepted == false ? "with-icon" : ""}`}>
                                                                                {this.displayAvailability(bid.bid.sellerAvailability)}
                                                                            </div>
                                                                            {this.props.isRequestAccepted == false &&
                                                                                <div className={"edit-icon"} onClick={() => this.editSellerAvailability(bid.bid.sellerBidHistoryID, bid.bid.sellerAvailability[0])} >
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
                                                                                        <g id="Group_13552" data-name="Group 13552" transform="translate(-564 -475)">
                                                                                            <g id="Group_13548" data-name="Group 13548" transform="translate(-288 -37.274)">
                                                                                                <circle id="Ellipse_471" data-name="Ellipse 471" cx="16.5" cy="16.5" r="16.5" transform="translate(852 512.274)" fill="#ffc542" opacity="0.135" />
                                                                                            </g>
                                                                                            <g id="pencil" transform="translate(572.391 483.398)">
                                                                                                <path id="Path_28967" data-name="Path 28967" d="M10.018,82.473,1.092,91.4A.356.356,0,0,0,1,91.562L.01,95.532a.351.351,0,0,0,.341.436.349.349,0,0,0,.085-.011l3.971-.989a.351.351,0,0,0,.163-.093L13.5,85.951Zm0,0" transform="translate(0 -79.764)" fill="#ffd01f" />
                                                                                                <path id="Path_28968" data-name="Path 28968" d="M339.024,1.738,338.03.744a1.8,1.8,0,0,0-2.485,0l-1.217,1.217,3.478,3.478,1.217-1.217a1.757,1.757,0,0,0,0-2.485Zm0,0" transform="translate(-323.315 -0.247)" fill="#ffd01f" />
                                                                                            </g>
                                                                                        </g>
                                                                                    </svg>
                                                                                </div>
                                                                                // <Icon name="edit" onClick={() => this.editSellerAvailability(bid.bid.sellerBidHistoryID, bid.bid.sellerAvailability[0])}></Icon>
                                                                            }
                                                                        </>
                                                                    }
                                                                    {(bid.bid.sellerBidHistoryID != this.state.editBidID) && (!bid.bid.sellerAvailability || bid.bid.sellerAvailability.length == 0) && this.props.isRequestAccepted == false &&
                                                                        <div className="edit-availability">
                                                                            <div className={"add-icon"} onClick={() => this.editSellerAvailability(bid.bid.sellerBidHistoryID, null)}>
                                                                                <svg id="add-button" xmlns="http://www.w3.org/2000/svg" width="21.023" height="21.023" viewBox="0 0 21.023 21.023">
                                                                                    <g id="Group_13301" data-name="Group 13301" transform="translate(0 0)">
                                                                                        <g id="Group_13300" data-name="Group 13300">
                                                                                            <path id="Path_28971" data-name="Path 28971" d="M20.147,9.636a.876.876,0,0,0-.876.876A8.759,8.759,0,1,1,16.728,4.34a.876.876,0,0,0,1.243-1.234,10.512,10.512,0,1,0,3.052,7.406A.876.876,0,0,0,20.147,9.636Z" transform="translate(0 0)" fill="#377dff" />
                                                                                        </g>
                                                                                    </g>
                                                                                    <g id="Group_13303" data-name="Group 13303" transform="translate(6.132 6.132)">
                                                                                        <g id="Group_13302" data-name="Group 13302">
                                                                                            <path id="Path_28972" data-name="Path 28972" d="M119.884,115.5h-2.628v-2.628a.876.876,0,1,0-1.752,0V115.5h-2.628a.876.876,0,1,0,0,1.752H115.5v2.628a.876.876,0,1,0,1.752,0v-2.628h2.628a.876.876,0,1,0,0-1.752Z" transform="translate(-112 -112)" fill="#377dff" />
                                                                                        </g>
                                                                                    </g>
                                                                                </svg>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {(bid.bid.sellerBidHistoryID == this.state.editBidID) && this.props.isRequestAccepted == false &&
                                                                        <React.Fragment>
                                                                            <div className="edit-availability edit-date-contianer">
                                                                                <Formsy>
                                                                                    <DGDateTimePicker name="editselleravailability" initialValue={bid.bid.sellerAvailability ? this.displayAvailability(bid.bid.sellerAvailability) : ''} onChange={this.onExistingSellerAvailabilityChange} />
                                                                                </Formsy>
                                                                            </div>
                                                                        </React.Fragment>
                                                                    }

                                                                </div>
                                                            </div>
                                                            <div className={"seller-expire-container"}>
                                                                <div className={"seller-container"}>
                                                                    <div className={"cell-heading"}>
                                                                        {"Seller"}
                                                                    </div>
                                                                    <div className={"seller-name"}>
                                                                        {bid.seller.name}
                                                                    </div>
                                                                </div>
                                                                <div className={"expire-container"}>
                                                                    <div className={"cell-heading"} style={{ display: "inline-block" }}>
                                                                        {"Expiring On"}
                                                                    </div>
                                                                    {!_.isEmpty(bid.bid.acceptedOn) && <div className="inline-bid-accepted-tag">
                                                                        <div>Accepted</div>
                                                                    </div>}
                                                                    <div className={"expire-date"}>{moment(bid.bid.bidOn).format('MMM DD YYYY')}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={"seperator"}>
                                                        </div>
                                                    </>
                                                )

                                                // <Table.Row className={!_.isEmpty(bid.bid.acceptedOn) ? 'accepted-row' : ''}>
                                                //     <Table.Cell>
                                                //         {this.getColumnHeaderForSmallerDevices('Price')}
                                                //         {(bid.bid.discountAmount > 0 || bid.bid.discountPercent > 0) &&
                                                //             <div><span style={{ textDecoration: 'line-through', width: '75px', display: 'inline-block' }}>{priceDisplay(bid.bid.price)}</span>
                                                //                 <span>{discountedPriceDisplay(bid.bid.price, bid.bid.discountPercent, bid.bid.discountAmount)}</span> </div>}

                                                //         {(!bid.bid.discountAmount && !bid.bid.discountPercent) && <div>
                                                //             <span>{priceDisplay(bid.bid.price)}</span>
                                                //         </div>
                                                //         }
                                                //     </Table.Cell>
                                                //     <Table.Cell>
                                                //         {this.getColumnHeaderForSmallerDevices('Availability')}
                                                //         {(bid.bid.sellerBidHistoryID != this.state.editBidID) && bid.bid.sellerAvailability && bid.bid.sellerAvailability.length > 0 &&


                                                //             <div className="edit-availability">{this.displayAvailability(bid.bid.sellerAvailability)}
                                                //                 &nbsp;{this.props.isRequestAccepted == false && <Icon name="edit" onClick={() => this.editSellerAvailability(bid.bid.sellerBidHistoryID, bid.bid.sellerAvailability[0])}></Icon>}
                                                //             </div>
                                                //         }

                                                //         {(bid.bid.sellerBidHistoryID != this.state.editBidID) && (!bid.bid.sellerAvailability || bid.bid.sellerAvailability.length == 0) && this.props.isRequestAccepted == false &&


                                                //             <div className="edit-availability">
                                                //                 &nbsp;<Icon name="add circle" onClick={() => this.editSellerAvailability(bid.bid.sellerBidHistoryID, null)}></Icon>
                                                //             </div>
                                                //         }

                                                //         {(bid.bid.sellerBidHistoryID == this.state.editBidID) && this.props.isRequestAccepted == false &&
                                                //             <React.Fragment>

                                                //                 <div className="edit-availability">
                                                //                     <Formsy>
                                                //                         <DGDateTimePicker name="editselleravailability" initialValue={bid.bid.sellerAvailability ? this.displayAvailability(bid.bid.sellerAvailability) : ''} onChange={this.onExistingSellerAvailabilityChange} />
                                                //                         <div className="save">
                                                //                             <Icon name="check circle outline" onClick={this.confirmSellerAvailabilityEdit} /> &nbsp;
                                                //                         </div>
                                                //                         <div className="cancel">
                                                //                             <Icon name="delete " onClick={this.cancelEditSellerAvailability} /> &nbsp;
                                                //                         </div>
                                                //                     </Formsy>
                                                //                 </div>
                                                //             </React.Fragment>
                                                //         }
                                                //     </Table.Cell>
                                                //     <Table.Cell>
                                                //         {this.getColumnHeaderForSmallerDevices('Seller')}
                                                //         <div>{bid.seller.name}</div>
                                                //     </Table.Cell>
                                                //     <Table.Cell style={!_.isEmpty(bid.bid.acceptedOn) ? { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } : {}}>
                                                //         {this.getColumnHeaderForSmallerDevices('Date/Time')}
                                                //         <div>{moment(bid.bid.bidOn).format('MMM DD YYYY')}</div>

                                                //         {!_.isEmpty(bid.bid.acceptedOn) && <div className="accepted-tag-new">
                                                //             <div>Accepted</div>
                                                //         </div>}
                                                //     </Table.Cell>
                                                // </Table.Row>
                                            })
                                        }



                                        {/* <Table>

                                <Table.Body className="table-body">
                                    {!_.isEmpty(bids) &&
                                        bids.map((bid, bidIndex) => {
                                            return <Table.Row className={!_.isEmpty(bid.bid.acceptedOn) ? 'accepted-row' : ''}>
                                                <Table.Cell>
                                                    {this.getColumnHeaderForSmallerDevices('Price')}
                                                    {(bid.bid.discountAmount > 0 || bid.bid.discountPercent > 0) &&
                                                        <div><span style={{ textDecoration: 'line-through', width: '75px', display: 'inline-block' }}>{priceDisplay(bid.bid.price)}</span>
                                                            <span>{discountedPriceDisplay(bid.bid.price, bid.bid.discountPercent, bid.bid.discountAmount)}</span> </div>
                                                    }

                                                    {(!bid.bid.discountAmount && !bid.bid.discountPercent) && <div>
                                                        <span>{priceDisplay(bid.bid.price)}</span>
                                                    </div>
                                                    }
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {this.getColumnHeaderForSmallerDevices('Availability')}
                                                    {(bid.bid.sellerBidHistoryID != this.state.editBidID) && bid.bid.sellerAvailability && bid.bid.sellerAvailability.length > 0 &&


                                                        <div className="edit-availability">{this.displayAvailability(bid.bid.sellerAvailability)}
                                                            &nbsp;{this.props.isRequestAccepted == false && <Icon name="edit" onClick={() => this.editSellerAvailability(bid.bid.sellerBidHistoryID, bid.bid.sellerAvailability[0])}></Icon>}
                                                        </div>
                                                    }

                                                    {(bid.bid.sellerBidHistoryID != this.state.editBidID) && (!bid.bid.sellerAvailability || bid.bid.sellerAvailability.length == 0) && this.props.isRequestAccepted == false &&


                                                        <div className="edit-availability">
                                                            &nbsp;<Icon name="add circle" onClick={() => this.editSellerAvailability(bid.bid.sellerBidHistoryID, null)}></Icon>
                                                        </div>
                                                    }

                                                    {(bid.bid.sellerBidHistoryID == this.state.editBidID) && this.props.isRequestAccepted == false &&
                                                        <React.Fragment>

                                                            <div className="edit-availability">
                                                                <Formsy>
                                                                    <DGDateTimePicker name="editselleravailability" initialValue={bid.bid.sellerAvailability ? this.displayAvailability(bid.bid.sellerAvailability) : ''} onChange={this.onExistingSellerAvailabilityChange} />
                                                                    <div className="save">
                                                                        <Icon name="check circle outline" onClick={this.confirmSellerAvailabilityEdit} /> &nbsp;
                                                                    </div>
                                                                    <div className="cancel">
                                                                        <Icon name="delete " onClick={this.cancelEditSellerAvailability} /> &nbsp;
                                                                    </div>
                                                                </Formsy>
                                                            </div>
                                                        </React.Fragment>
                                                    }
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {this.getColumnHeaderForSmallerDevices('Seller')}
                                                    <div>{bid.seller.name}</div>
                                                </Table.Cell>
                                                <Table.Cell style={!_.isEmpty(bid.bid.acceptedOn) ? { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } : {}}>
                                                    {this.getColumnHeaderForSmallerDevices('Date/Time')}
                                                    <div>{moment(bid.bid.bidOn).format('MMM DD YYYY')}</div>

                                                    {!_.isEmpty(bid.bid.acceptedOn) && <div className="accepted-tag-new">
                                                        <div>Accepted</div>
                                                    </div>}
                                                </Table.Cell>
                                            </Table.Row>
                                        })
                                    }
                                </Table.Body>
                            </Table> */}

                                    </div>
                                </div>
                            </>
                    }
                </div>
            </>
        )
    }
}

export default ServiceRequestBidHistory
